import { CircularProgress } from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './LoadingPlaceHolder.scss';

const defaultProps = {
  message: '',
};

const LoadingPlaceHolder = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { message } = mergedProps;
  return (
    <div className='loading-placeholder-loading'>
      <CircularProgress size={40} />
      <div className='loading-message'>
        {message}
      </div>
    </div>
  );
};

export default LoadingPlaceHolder;
